<template>
  <div>
    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-r">
          <el-card style="width: 29%">
            <div class="topbarnav">
              <img src="../../../assets/images/icons/1.png" alt />
              <div>概览</div>
            </div>
            <div class="onebuttom">
              <div class="totalBox">
                <div class="totalItem">
                  <p class="total">
                    {{ systemUserStatistics.userCount }}
                  </p>
                  <p class="name">总注册用户</p>
                </div>
                <div class="totalItem totalItemBg">
                  <p class="total">
                    {{ systemUserStatistics.webUserCount }}
                  </p>
                  <p class="name">WEB用户</p>
                </div>
                <div class="totalItem totalItemBg">
                  <p class="total">
                    {{ systemUserStatistics.appUserCount }}
                  </p>
                  <p class="name">APP用户</p>
                </div>
                <div class="totalItem totalItemBg">
                  <p class="total">
                    {{ systemUserStatistics.publicUserCount }}
                  </p>
                  <p class="name">微信公众号用户</p>
                </div>
              </div>
            </div>
          </el-card>
          <el-card style="width: 34%">
            <div class="topbarnav">
              <img src="../../../assets/images/icons/14.png" alt />
              <div>近7日用户统计</div>
            </div>
            <div class="onebuttom">
              <div class="onebuttom-chart" id="chart_1_1"></div>
            </div>
          </el-card>
          <el-card style="width: 34%">
            <div class="topbarnav">
              <img src="../../../assets/images/icons/14.png" alt />
              <div>近7日用户活跃度统计</div>
            </div>
            <div class="onebuttom">
              <div class="onebuttom-chart" id="chart_1_2"></div>
            </div>
          </el-card>
        </div>
        <div class="table-box">
          <global-tag>
            <el-form
              :inline="true"
              :model="searchlist"
              class="demo-form-inline"
            >
              <el-form-item label="用户名:">
                <el-input
                  v-model="searchlist.loginName"
                  placeholder="请输入用户名"
                ></el-input>
              </el-form-item>
              <el-form-item label="姓名:">
                <el-input
                  v-model="searchlist.name"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号:">
                <el-input
                  v-model="searchlist.mobile"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属区域:">
                <el-cascader
              ref="orgId"
              style="width: 260px"
              :options="orgTree"
              v-model="searchlist.orgId"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'label',
                value: 'orgId',
              }"
              clearable
            >
            </el-cascader>
              </el-form-item>
              <el-form-item label="用户角色:">
                <el-select
              v-model="searchlist.roleId"
              style="width: 260px"
              placeholder="请选择"
            >
              <el-option
                v-for="item in ruleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchlistdata"
                  >查询
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="info" @click="searchlistReset"
                  >重置
                </el-button>
              </el-form-item>
              <el-form-item></el-form-item>
            </el-form>
          </global-tag>
          <div class="three">
            <el-button
              type="primary"
              size="mini"
              v-if="orgLevel !== 4"
              @click="showDialogForm(0, 'add')"
              >新增
            </el-button>
            <!-- <el-button type="danger" size="mini">导出Excel</el-button> -->
          </div>
          <!-- 表格盒子 -->
          <div class="table_card">
            <el-table
              :data="tableData"
              :header-cell-style="{ background: '#f8fafa' }"
              border
              highlight-current-row
            >
              <el-table-column
                type="selection"
                align="center"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="loginName"
                label="用户名"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="姓名"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="mobile"
                label="手机号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="createDate"
                label="注册时间"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="loginDate"
                label="最后登陆时间"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="loginIp"
                label="登录IP"
              ></el-table-column>
              <el-table-column
                align="center"
                label="操作"
                width="200"
                fixed="right"
              >
                <template slot-scope="scope">
                  <!-- 包裹按钮的悬浮提示 -->
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="查看"
                    placement="top-start"
                  >
                    <el-button
                      type="text"
                      icon="el-icon-tickets"
                      style="font-size: 18px; color: #c3c3c3"
                      @click="showDialogForm(scope.row.id, 'detail')"
                    ></el-button>
                    <!-- <button
                        class="
                            iconfont
                            icon-chakan
                            tabBtn tabBtn-detail
                        "
                        @click="
                            showDialogForm(
                                scope.row.id,
                                'detail'
                            )
                        "
                    ></button> -->
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="修改"
                    placement="top-start"
                  >
                    <el-button
                      v-if="orgLevel !== 4"
                      type="text"
                      icon="el-icon-edit-outline"
                      style="font-size: 18px; color: #379dd1"
                      @click="showDialogForm(scope.row.id, 'edit')"
                    ></el-button>
                    <!-- <button
                        v-if="orgLevel !== 4"
                        class="
                            iconfont
                            icon-bianji3
                            tabBtn tabBtn-edit
                        "
                        @click="
                            showDialogForm(
                                scope.row.id,
                                'edit'
                            )
                        "
                    ></button> -->
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="删除"
                    placement="top-start"
                  >
                    <el-button
                      :disabled="scope.row.isPromiseDelete == 0"
                      v-if="orgLevel !== 4"
                      type="text"
                      icon="el-icon-delete"
                      style="font-size: 18px; color: #dc3020"
                      @click="showdeletepanduan(scope.row.id)"
                    ></el-button>
                    <!-- <button
                        :disabled="
                            scope.row.isPromiseDelete ==
                            0
                        "
                        v-if="orgLevel !== 4"
                        class="
                            iconfont
                            icon-icon7
                            tabBtn tabBtn-delete
                        "
                        @click="
                            showdeletepanduan(
                                scope.row.id
                            )
                        "
                    ></button> -->
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="修改密码"
                    placement="top-start"
                  >
                    <el-button
                      type="text"
                      icon="el-icon-refresh-right"
                      style="font-size: 18px; color: #2e99cf"
                      @click="ChangePassword('修改密码', scope.row)"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页功能 -->
            <el-pagination
              :page-size="pageConfig.pageSize"
              layout="total, prev, pager, next, jumper"
              @current-change="handleCurrentChange"
              :total="pageConfig.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出框新增 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="1100px"
      :close-on-click-modal="false"
      :before-close="clearadddata"
    >
      <div id="addForm">
        <el-form
          ref="rowData"
          :rules="rules"
          :model="rowData"
          label-width="120px"
          size="mini"
          :disabled="editDisable"
        >
          <el-form-item label="登录名:" prop="loginName">
            <el-input
              :disabled="editDisable || flag == 'edit'"
              v-model="rowData.loginName"
              placeholder="请输入登录名"
              @input="changeLogin"
            ></el-input>
          </el-form-item>
          <!-- @input="clearForm" -->
          <el-form-item label="用户姓名:" prop="name">
            <el-autocomplete
              class="inline-input"
              style="width: 100%"
              v-model.lazy="rowData.name"
              :fetch-suggestions="remoteMethod"
              auto-complete="new-name"
              placeholder="请输入内容"
              :trigger-on-focus="false"
              @select="changePerson"
              @input="clearForm"
              @blur="rowDataName"
            >
              <template v-slot="{ item }">
                <span>{{ item.personName }}</span>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item label="用户密码:" prop="password" v-if="infoshow">
            <el-input
              :disabled="editDisable"
              v-model="rowData.password"
              show-password
              @input="changePassword"
              auto-complete="new-password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <!-- v-if="infoshow" -->
          <el-form-item v-if="infoshow" label="确认密码:" prop="confirmPwd">
            <el-input
              :disabled="editDisable"
              v-model="rowData.confirmPwd"
              show-password
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="mobile">
            <el-input
              :disabled="editDisable || isSend"
              v-model="rowData.mobile"
              placeholder="请输入手机号码"
              @blur="checkMobile"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否党员:" prop="partyMemberFlag">
            <el-radio-group
              :disabled="editDisable"
              v-model="rowData.partyMemberFlag"
            >
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="身份证:" prop="idCardNo">
            <el-input
              :disabled="editDisable || isSend"
              v-model="rowData.idCardNo"
              @change="cardChange"
              placeholder="请输入身份证号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别:" prop="gender">
            <el-radio-group disabled v-model="rowData.gender">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="机构选择:" prop="orgId">
            <el-cascader
              ref="orgId"
              :disabled="editDisable || isSend"
              style="width: 260px"
              :options="orgTree"
              v-model="rowData.orgId"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'label',
                value: 'orgId',
              }"
              clearable
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="是否服务人员:" prop="sysType">
            <el-radio-group
              :disabled="editDisable || flag == 'edit' || isSend"
              v-model="rowData.sysType"
            >
              <!-- :disabled="sysTypeDisable" -->
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="授权角色:" prop="roleids">
            <el-select
              :disabled="editDisable"
              v-model="rowData.roleids"
              style="width: 260px"
              placeholder="请选择"
              @change="role"
            >
              <el-option
                v-for="item in ruleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员类别:">
            <el-checkbox-group
              :disabled="editDisable"
              v-model="rowData.userType"
            >
              <el-checkbox label="1">WEB</el-checkbox>
              <el-checkbox label="2">APP</el-checkbox>
              <el-checkbox label="3">微信公众号</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- <el-form-item label="查看授权:" prop="orgIds">
            <el-button @click="showAuthorDialog">点击选择 </el-button>
          </el-form-item> -->

          <el-form-item label="职位:" prop="postIds">
            <el-select
              :disabled="editDisable"
              v-model="rowData.postIds"
              multiple
              style="width: 260px"
              placeholder="请选择"
            >
              <el-option
                v-for="item in postList"
                :key="item.id + item.postName"
                :label="item.postName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否工单补录:" prop="pgdRecord">
            <el-radio-group :disabled="editDisable" v-model="rowData.pgdRecord">
              <!-- :disabled="sysTypeDisable" -->
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="隐私权限:" prop="privateFlag" v-if="isRole">
            <el-radio-group v-model="rowData.privateFlag">
              <!-- :disabled="sysTypeDisable" -->
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态:" prop="useStatus">
            <el-radio-group v-model="rowData.useStatus">
              <!-- :disabled="sysTypeDisable" -->
              <el-radio label="0">启用</el-radio>
              <el-radio label="1">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-upload
            style="
              width: 250px;
              height: 250px;
              position: absolute;
              right: 30px;
              top: 70px;
            "
            class="avatar-uploader"
            :action="uploadUrl"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :before-upload="beforeAvatarUpload"
            name="file"
          >
            <img
              alt=""
              v-if="rowData.photo"
              :src="rowData.photo"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 5px;
          "
        >
          <el-button
            v-if="!editDisable"
            type="primary"
            size="small"
            style="margin: 0 30px"
            @click="saveadddata('rowData')"
            ><strong>保存</strong></el-button
          >
          <el-button type="info" size="small" @click="clearadddata"
            >关闭
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!--    授权数据弹框-->
    <el-dialog
      title="授权数据"
      :close-on-click-modal="false"
      :visible.sync="authorDialogVisible"
      width="500px;"
      :before-close="onAuthorDialogClose"
    >
      <div style="display: flex">
        <div style="width: 80px">选择机构:</div>
        <!--        check-strictly 父子选择互不相干-->
        <el-tree
          ref="orgTree1"
          :data="orgTree1"
          show-checkbox
          node-key="orgId"
          check-strictly
          default-expand-all
          :props="defaultProps"
        >
        </el-tree>
      </div>
      <div
        style="
          margin-top: 15px;
          padding-top: 15px;
          display: flex;
          justify-content: flex-end;
          border-top: 1px solid #ccc;
        "
      >
        <template v-if="editDisable">
          <el-button size="medium" type="primary" @click="onAuthorDialogClose"
            >关闭
          </el-button>
        </template>
        <template v-else>
          <el-button size="medium" @click="onAuthorDialogClose"
            >取消
          </el-button>
          <el-button size="medium" type="primary" @click="saveAuthor"
            >确定
          </el-button>
        </template>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTitles"
      :visible.sync="showDialogs"
      width="500px"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form
        :model="addForms"
        label-width="110px"
        :rules="addFormsRul"
        ref="addFormsRef"
      >
        <el-form-item label="旧密码：" prop="oldPassword">
          <el-input
            v-model="addForms.oldPassword"
            auto-complete="new-password"
            show-password
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="password">
          <el-input
            v-model="addForms.password"
            auto-complete="new-password"
            show-password
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirmPwd">
          <el-input
            v-model="addForms.confirmPwd"
            auto-complete="new-password"
            show-password
            size="mini"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 5px;
        "
      >
        <el-button
          type="primary"
          size="small"
          style="margin: 0 30px"
          @click="senddata()"
          ><strong>保存</strong></el-button
        >
        <el-button type="info" size="small" @click="closeDialog"
          >关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp"
import "@/assets/css/system.css"
import echarts_msg from "../../../utils/echarts.js"
import request from "../../../utils/request.js"
import common from "../../../utils/common.js"

export default {
  data() {
    const confirmPass = (rule, value, callback) => {
      if (value) {
        if (this.rowData.password !== value) {
          callback(new Error("两次输入的密码不一致"))
        } else {
          callback()
        }
      } else {
        callback(new Error("请再次输入密码"))
      }
    }
    const confirmPass1 = (rule, value, callback) => {
      if (value) {
        if (this.addForms.password !== value) {
          callback(new Error("两次输入的密码不一致"))
        } else {
          callback()
        }
      } else {
        callback(new Error("请再次输入密码"))
      }
    }
    var checkLoginName = (rule, value, callback) => {
      if (this.flag == "edit") {
        callback()
      } else {
        if (!value) {
          return callback(new Error("登录名不能为空"))
        }
        setTimeout(() => {
          request({
            url: "/rbac/admin/user/info/checkLoginName",
            method: "POST",
            data: { loginName: value },
          }).then((res) => {
            if (res.content) {
              callback()
            } else {
              return callback(new Error(res.message))
            }
          })
        }, 1000)
      }
    }

    return {
      addForms: {},
      showDialogs: false,
      dialogTitles: "",
      activeInfo: {
        data: [],
        times: [],
      },
      userTotal: {
        times: [],
        appSevenDays: [],
        publicSevenDays: [],
        webSevenDays: [],
      },
      dialogTitle: "新增",
      flag: "add",
      isSend: false,
      showDialog: false,
      editDisable: false,
      sysTypeDisable: false,
      infoshow: true,
      rowData: {
        userType: [],
        orgName: "",
        orgId: "",
        orgType: "",
        shengjiId: "",
        partyMemberFlag: "",
        sysType: "",
        shijiId: "",
        qujiId: "",
        stationId: "",
        shequjiId: "",
        servePerson: null,
        roleids: "",
        pgdRecord: "",
        useStatus: "0",
      },
      wmsysType: "0",
      wmpartyMemberFlag: "0",
      orgLevels: "",
      isRole: false,
      // 树形控件的配置
      defaultProps: {
        // children: 'children',
        // label: 'label'
        checkStrictly: true,
        value: "orgId",
        label: "label",
      },
      systemUserStatistics: {
        appUserCount: 0,
        publicUserCount: 0,
        userCount: 0,
        webUserCount: 0,
      },
      addFormsRul: {
        oldPassword: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: "请输入6-20位字符",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: "请输入6-20位字符",
            trigger: "blur",
          },
        ],
        confirmPwd: [
          {
            required: true,
            validator: confirmPass1,
            trigger: "blur",
          },
        ],
      },
      rules: {
        loginName: [
          {
            required: true,
            validator: checkLoginName,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 20,
            message: "请输入6-20位字符",
            trigger: "blur",
          },
        ],
        confirmPwd: [
          { required: true, validator: confirmPass, trigger: "blur" },
        ],
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
        ],
        orgId: {
          required: true,
          message: "请选择机构",
          trigger: "change",
        },
        partyMemberFlag: [
          {
            required: true,
            message: "请选择是否党员",
            trigger: "blur",
          },
        ],
        sysType: [
          {
            required: true,
            message: "请选择是否是服务人员",
            trigger: "blur",
          },
        ],
        pgdRecord: [
          {
            required: true,
            message: "请选择工单补录",
            trigger: "blur",
          },
        ],
        privateFlag: [
          {
            required: true,
            message: "请选择老人隐私权限:",
            trigger: "blur",
          },
        ],
        useStatus: [
          {
            required: true,
            message: "请选择状态:",
            trigger: "change",
          },
        ],
        idCardNo: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur",
          },
          {
            pattern:
              /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: "证件号码格式有误！",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入用户手机号",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "请输入11位手机号码",
            trigger: "blur",
          },
        ],
      },
      uploadUrl:
        request.defaults.baseURL +
        "/rbac/controller/uploadController/info/uploadPhoto",
      //列表数据
      searchlist: {
        shengjiId: "",
        shijiId: "",
        qujiId: "",
        stationId: "",
        shequjiId: "",
      },
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      orgLevel: "",
      arrOrgList: [],
      // 角色列表
      ruleList: [],
      // 机构树
      orgTree: [],
      orgTree1: [],
      postList: [],
      authorDialogVisible: false,
      personList: [],
      loading: false,
    }
  },
  methods: {
    role(e) {
      if (e == 1) {
        this.rowData.privateFlag = 1
        this.isRole = false
      } else {
        this.isRole = true
      }
      this.$forceUpdate()
    },
    cardChange(val) {
      let pattern =
        /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/
      if (!pattern.test(val)) {
        this.$message.error("身份证填写有误")
        return
      }
      // 性别
      if (val.length == 18) {
        if (val.charAt(16) % 2 == 0) {
          this.rowData.gender = "2"
        } else {
          this.rowData.gender = "1"
        }
      } else if (val.length == 15) {
        if (val.charAt(14) % 2 == 0) {
          this.rowData.gender = "2"
        } else {
          this.rowData.gender = "1"
        }
      }
      this.$forceUpdate()
    },
    rowDataName() {
      this.rowData.name != ""
        ? (this.sysTypeDisable = true)
        : (this.sysTypeDisable = false)
    },
    // 选中人员
    clearForm(val) {
      this.rowData.name = val
      if (this.isSend == true) {
        this.isSend = false
        this.$refs.rowData.resetFields()
        this.rowData.name = val
      }
      // val? this.sysTypeDisable = true :  this.sysTypeDisable = false;
    },

    changePerson(item) {
      // this.$refs.rowData.resetFields()
      this.isSend = true
      this.rowData.name = item.personName
      this.rowData.servePerson = item.id
      this.rowData.idCardNo = item.personIdentity
      this.rowData.gender = item.personSex
      this.rowData.mobile = item.personPhone
      this.rowData.sysType = "1"
      this.rowData.photo = item.personPhoto ? item.personPhoto : ""
      this.rowData.orgId = String(item.dataId)
      // this.rowData.orgId = this.changeDetSelect(
      //     item.dataId,
      //     "orgId",
      //     this.orgTree
      // )
      //  this.rowData.name? this.sysTypeDisable = true :  this.sysTypeDisable = false;
    },
    // 用户角色
    getRoleIds(id) {
      request({
        url: "/rbac/admin/user/info/findUserRoleList",
        method: "POST",
        data: {
          createId: id,
          pageNo: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        if (res.code == 200) {
        } else {
          this.$message({
            message: res.message,
            type: "error",
          })
        }
      })
    },
    // 搜索用户名
    remoteMethod(query, cb) {
      let result = this.personList.filter((item) => {
        if (item.personName.indexOf(query) > -1) {
          return true
        }
      })
      cb(result)
    },
    // 获取服务人员信息
    getPerson() {
      request({
        url: "/ypt/admin/serviceStaff/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 10000,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.personList = res.content ? res.content.list : []
        } else {
          this.$message({
            message: res.message,
            type: "error",
          })
        }
      })
    },
    // 获取树
    async getTree() {
      let data = {}
      if (this.rowData.roleids != "" || this.rowData.roleids != null) {
        data.id = this.rowData.roleids
      } else {
        data.ids = this.rowData.roleids
      }
      const { content } = await post(
        "/rbac/admin/role/info/findRoleDataList",
        data
      )
      this.$nextTick(() => {
        this.$refs.orgTree1.setCheckedKeys(content || [], true)
      })
    },
    // 保存授权数据
    async saveAuthor() {
      // this.rowData.orgIds = this.$refs.orgTree.getCheckedKeys()
      this.onAuthorDialogClose()
    },
    // 授权数据弹框关闭
    onAuthorDialogClose() {
      this.authorDialogVisible = false
    },
    // 授权角色弹框显示
    async showAuthorDialog() {
      if (this.rowData.roleids != "" || this.rowData.roleids != null) {
        this.authorDialogVisible = true
        this.getTree()
        this.getOrgTree1()
      } else {
        this.$message.warning("请选择角色")
      }
    },
    // 获取所有职位列表
    async getPostList() {
      const { content } = await post("/rbac/admin/post/list", {
        ...this.searchlist,
        ...this.pageConfig,
      })
      this.postList = content.list || []
    },
    // 获取机构树
    async getOrgTree() {
      const { content } = await post("/rbac/admin/org/info/OrgTreelist", {
        isValid: 1,
      })
      //this.orgTree = content
      this.orgTree = content ? content : []
    },
    async getOrgTree1() {
      const { content } = await post("/rbac/admin/org/info/OrgTreelist", {
        isValid: 1,
      })

      content.forEach((item) => {
        item.disabled = true
        if (item.children && item.children.length > 0) {
          item.disabled = true
          item.children.forEach((item1) => {
            item1.disabled = true
            if (item1.children && item1.children.length > 0) {
              item1.children.forEach((item2) => {
                item2.disabled = true
                if (item2.children && item2.children.length > 0) {
                  item2.children.forEach((item3) => {
                    item3.disabled = true
                    if (item3.children && item3.children.length > 0) {
                      item3.children.forEach((item4) => {
                        item4.disabled = true
                        if (item4.children && item4.children.length > 0) {
                          item4.children.forEach((item5) => {
                            item5.disabled = true
                          })
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
      this.orgTree1 = content
    },
    //修改密码
    ChangePassword(titel, row) {
      this.dialogTitles = titel
      this.showDialogs = true
      this.addForms.id = row.id
    },
    async senddata() {
      const { code, content } = await post(
        "/rbac/admin/user/info/checkOldPassword",
        {
          ...this.addForms,
        }
      )
      if (code === 200) {
        this.xiugai()
      }
    },
    async xiugai() {
      const { code, content } = await post(
        "/rbac/admin/user/info/updatPassWord",
        {
          id: this.addForms.id,
          password: this.addForms.password,
        }
      )
      if (code === 200) {
        if (content == 1) {
          if (this.addForms.confirmPwd && this.addForms.password) {
            this.$router.push({ path: "/login" })
          }
        }
        this.addForms = {
          oldPassword: "",
          password: "",
          confirmPwd: "",
        }
        this.showDialogs = false
        this.getPageDatas()
      }
    },
    closeDialog() {
      this.addForms = {
        oldPassword: "",
        password: "",
        confirmPwd: "",
      }
      this.showDialogs = false
      this.$refs["addFormsRef"].resetFields()
    },
    // 获取所有角色列表
    async getRoleList() {
      const { code, content } = await post("/rbac/admin/role/info/list", {
        pageNo: 1,
        pageSize: 999,
        useable: 1,
      })
      if (code === 200) {
        this.ruleList = content.list || []
      }
    },
    // 验证手机号是否已注册
    changeLogin(val) {
      // this.$forceUpdate()
    },
    changePassword(val) {
      // this.$forceUpdate()
    },
    checkMobile() {
      if (this.rowData.mobile != "") {
        this.$http
          .request({
            url: "rbac/admin/user/info/getByIdphone",
            method: "POST",
            data: {
              mobile: this.rowData.mobile,
            },
          })
          .then((res) => {
            if (res.code === 200) {
              if (res.content != null && res.content.name == 1) {
                this.$message.error("手机号已存在！")
                this.rowData.mobile = ""
              }
            } else if (res.code == "10004") {
              this.$message.error(res.message)
              this.$router.push("/login")
            }
          })
      }
    },
    getOrgLevel() {
      post("rbac/admin/user/info/getLoginUserInfo", {
        id: this.$store.state.id,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content[0]) {
            this.orgLevels = res.content[0].orgLevel
          }
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset() {
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getPageDatas()
    },
    //获取列表数据
    async getPageDatas() {
      this.searchlist.pageNo = this.pageConfig.pageNo
      this.searchlist.pageSize = this.pageConfig.pageSize
      this.searchlist.qujiId = JSON.parse(
        localStorage.getItem("czUserInfo")
      ).qujiId
      this.searchlist.shengjiId = JSON.parse(
        localStorage.getItem("czUserInfo")
      ).shengjiId
      this.searchlist.shijiId = JSON.parse(
        localStorage.getItem("czUserInfo")
      ).shijiId
      this.searchlist.stationId = JSON.parse(
        localStorage.getItem("czUserInfo")
      ).stationId
      this.searchlist.shequjiId = JSON.parse(
        localStorage.getItem("czUserInfo")
      ).shequjiId
      let params = JSON.stringify(this.searchlist)
      const { code, content } = await post("/rbac/admin/user/info/list", params)
      if (code === 200) {
        if (content != null) {
          this.pageConfig.total = content.count
          this.tableData = content.list
        } else {
          this.pageConfig.total = 0
          this.tableData = []
        }
      } else {
        this.$message.error("数据加载异常")
      }
    },
    //  近七日统计
    chartStatistics() {
      const myChart = this.$echarts.init(document.getElementById("chart_1_1"))

      let xData = this.userTotal.times

      let yData = [
        {
          name: "WEB用户",
          type: "bar",
          stack: "注册用户",
          emphasis: {
            focus: "series",
          },
          data: this.userTotal.webSevenDays,
        },
        {
          name: "APP用户",
          type: "bar",
          stack: "注册用户",
          emphasis: {
            focus: "series",
          },
          data: this.userTotal.appSevenDays,
        },
        {
          name: "微信公众号用户",
          type: "bar",
          stack: "注册用户",
          emphasis: {
            focus: "series",
          },
          data: this.userTotal.publicSevenDays,
        },
      ]
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },

        xAxis: {
          type: "category",
          data: xData,
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            interval: 0,
            rotate: 90,
          },
        },
        yAxis: [
          {
            type: "value",
          },
        ],
        series: yData,
      })

      const sizeFun = function () {
        myChart.resize()
      }
      window.addEventListener("resize", sizeFun)
    },
    getChartStatistics() {
      this.$http
        .request({
          url: "/rbac/admin/user/info/sevenDaysStatistics",
          method: "POST",
          data: {},
        })
        .then((wres) => {
          if (wres.code === 200) {
            let arry = []
            let appSevenDays = []
            let publicSevenDays = []
            let webSevenDays = []
            if (wres.content.appSevenDays) {
              wres.content.appSevenDays.forEach((item) => {
                arry.push(item.time)
                appSevenDays.push(item.count)
              })
            }
            if (wres.content.publicSevenDays) {
              wres.content.publicSevenDays.forEach((item) => {
                publicSevenDays.push(item.count)
              })
            }
            if (wres.content.webSevenDays) {
              wres.content.webSevenDays.forEach((item) => {
                webSevenDays.push(item.count)
              })
            }
            this.userTotal = {
              times: arry,
              appSevenDays: appSevenDays,
              publicSevenDays: publicSevenDays,
              webSevenDays: webSevenDays,
            }
            this.chartStatistics()
          }
        })
    },
    // 近七日用户活跃度统计
    chartActivity() {
      const option_1_2_text = this.activeInfo.times
      const option_1_2_data = [
        {
          data: this.activeInfo.data,
          type: "line",
          smooth: true,
        },
      ]
      const myChart_1_2 = this.$echarts.init(
        document.getElementById("chart_1_2")
      )
      const option_1_2 = echarts_msg.option_line
      option_1_2.xAxis.data = option_1_2_text
      option_1_2.series = option_1_2_data
      myChart_1_2.setOption(option_1_2)
      const sizeFun = function () {
        myChart_1_2.resize()
      }
      window.addEventListener("resize", sizeFun)
    },
    getChartActivity() {
      this.$http
        .request({
          url: "/rbac/admin/user/info/sevenDaysActivityStatistics",
          method: "POST",
          data: {},
        })
        .then((wres) => {
          if (wres.code === 200) {
            let data = []
            let times = []
            if (wres.content) {
              wres.content.forEach((item) => {
                data.push(item.count)
                times.push(item.time)
              })
            }
            // this.activeInfo=wres.content
            this.activeInfo = {
              data: data,
              times: times,
            }
            this.chartActivity()
          }
        })
    },
    drawChart() {
      //  近七日统计
      this.getChartStatistics()
      // 近七日用户活跃度统计
      this.getChartActivity()
    },
    async showDialogForm(id, flag) {
      this.flag = flag
      if (id != "") {
        this.sysTypeDisable = true
        if (flag == "edit") {
          this.editDisable = false
          this.dialogTitle = "编辑"
        } else if (flag == "detail") {
          this.editDisable = true
          this.dialogTitle = "查看"
        }
        this.infoshow = false
        //获取编辑项的最新数据
        let params = { id: id }
        const res = await request({
          url: "/rbac/admin/user/info/findById",
          method: "POST",
          data: params,
        })
        if (res.code === 200) {
          if (!res.content) return
          this.rowData = res.content
          if (res.content.roleIds != null) {
            this.rowData.roleids = res.content.roleIds.toString()
            this.rowData.roleids = parseInt(this.rowData.roleids)
            if (this.rowData.roleids == 1) {
              this.isRole = false
            } else {
              this.isRole = true
            }
            this.$forceUpdate()
          }

          this.rowData.orgId = String(this.rowData.orgId)
          // // 机构回显
          // if (res.content.orgId) {
          //     res.content.orgId = this.changeDetSelect(
          //         res.content.orgId,
          //         "orgId",
          //         this.orgTree
          //     )
          // }

          // 职位回显
          if (res.content.postIds) {
            res.content.postIds = res.content.postIds.map((item) => {
              return parseInt(item)
            })
          }

          this.rowData.sysType = this.rowData.sysType
            ? this.rowData.sysType
            : "0"
          if (this.rowData.sysType != null) {
            this.rowData.sysType = this.rowData.sysType.toString()
          }
          if (res.content.userType) {
            this.rowData.userType = res.content.userType.split(",")
          }
          this.showDialog = true
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        } else {
          this.$message.error("数据项加载异常")
          this.showDialog = false
        }
      } else {
        this.getPerson()
        this.editDisable = false
        this.showDialog = true
        this.infoshow = true
        this.dialogTitle = "新增"
        this.rowData.partyMemberFlag = "0"
        this.rowData.sysType = "0"
        this.rowData.pgdRecord = "0"
        // this.rowData.name = ""
        // this.rowData.password = ""
      }
    },
    //回显(多级)
    changeDetSelect(value, key, treeData) {
      let arr = [] // 在递归时操作的数组
      let returnArr = [] // 存放结果的数组
      let depth = 0 // 定义全局层级
      // 定义递归函数
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j][key]
          if (childrenData[j][key] == value) {
            returnArr = arr.slice(0, depthN + 1) //将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].children) {
              depth++
              childrenEach(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }

      return childrenEach(treeData, depth)
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccess(response, file, fileList) {
      if (response.code === 200) {
        this.rowData.photo = response.content
      }
      this.$forceUpdate()
    },
    beforeAvatarUpload(file) {
      const isLtM = file.size / 1024 / 1024 < 2
      if (!isLtM) {
        this.$message.error("上传图片大小不能超过 2MB!")
      }
      return isLtM
    },
    //附件预览
    handlePreview(file) {
      window.open(file.url)
    },
    //获取新增所有数据发请求
    async saveadddata(fromdate) {
      if (this.rowData.userType != null) {
        this.rowData.userType = this.rowData.userType.toString()
      }
      if (this.rowData.mobile != "") {
        this.$http
          .request({
            url: "rbac/admin/user/info/getByIdphone",
            method: "POST",
            data: {
              mobile: this.rowData.mobile,
            },
          })
          .then((res) => {
            if (res.code === 200) {
              if (res.content != null && res.content.name !== 1) {
                this.$refs[fromdate].validate((valid) => {
                  if (valid) {
                    // try {
                    //   this.rowData.userType = JSON.stringify(
                    //     this.rowData.userType
                    //   )
                    // } catch (error) {
                    //   this.rowData.userType = this.rowData.userType.split(
                    //     ','
                    //   )
                    // }
                    // 处理机构选择
                    // if (
                    //     Array.isArray(this.rowData.orgId) &&
                    //     this.rowData.orgId.length > 0
                    // ) {
                    //     this.rowData.orgId =
                    //         this.rowData.orgId.pop()
                    // } else {
                    //     this.rowData.orgId = ""
                    // }
                    // 处理授权数据
                    // this.handleCascaderLast('orgIds')
                    // 处理职位
                    let obj = common.organization(
                      this.arrOrgList,
                      this.orgLevels
                    )
                    let arr = []
                    arr.push(this.rowData.roleids)
                    this.rowData.roleIds = arr
                    let params = this.rowData
                    params.qujiId = obj.qujiId
                    params.shengjiId = obj.shengjiId
                    params.shijiId = obj.shijiId
                    params.stationId = obj.stationId
                    params.shequjiId = obj.shequjiId
                    let url = "/rbac/admin/user/info/update"
                    if (this.flag === "add") {
                      url = "/rbac/admin/user/info/insert"
                    }
                    request({
                      url: url,
                      method: "POST",
                      data: params,
                    })
                      .then((res) => {
                        if (res.code === 200) {
                          this.$message({
                            message: this.dialogTitle + "成功",
                            type: "success",
                          })
                          if (res.content == 1) {
                            if (
                              this.rowData.confirmPwd &&
                              this.rowData.password
                            ) {
                              this.$router.push({
                                path: "/login",
                              })
                            }
                          }
                          this.showDialog = false
                          this.pageConfig.pageNo = 1
                          this.getPageDatas()
                          this.$refs.rowData.resetFields()
                        } else if (res.code === 202) {
                          this.$message({
                            message: this.dialogTitle + "失败:" + res.message,
                            type: "error",
                          })
                        } else {
                          this.$message({
                            message: this.dialogTitle + "失败:" + res.message,
                            type: "error",
                          })
                        }
                      })
                      .catch((err) => {
                        this.showDialog = false
                        // this.$refs.rowData.resetFields()
                      })
                  } else {
                    this.$message.error("请填写正确信息")
                  }
                })
              }
            } else if (res.code == "10004") {
              this.$message.error(res.message)
              this.$router.push("/login")
            }
          })
      }
    },
    // 处理级联选择器发送数组最后一项
    handleCascaderLast(name) {
      if (Array.isArray(this.rowData[name]) && this.rowData[name].length > 0) {
        this.rowData[name] = this.rowData[name].map((item) => {
          return item.pop()
        })
      } else {
        this.rowData[name] = null
      }
    },
    // 新增弹出框重置
    clearadddata() {
      this.showDialog = false
      this.$refs.rowData.resetFields()
      this.sysTypeDisable = false
    },
    //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let params = JSON.stringify({ id: id })
          const { code } = await request({
            url: "/rbac/admin/user/info/delete",
            method: "POST",
            data: params,
          })
          if (code === 200) {
            this.$message.success("删除成功")
            this.showDialog = false
            this.getPageDatas()
          } else {
            this.$message.error("删除失败")
          }
        })
        .catch(() => {
          this.$message.info("已取消删除")
        })
    },
    async loadSystemUserStatistics() {
      // 加载用户统计信息
      const { code, content } = await request({
        url: "/rbac/admin/system/log/userListReport",
        method: "POST",
        data: {},
      })
      if (code === 200) {
        this.systemUserStatistics = content
      }
    },
  },
  mounted() {
    this.getOrgTree()
    this.getRoleList()
    this.drawChart()
    this.getPageDatas()
    this.loadSystemUserStatistics()
    this.getOrgLevel()
    this.getPostList()
  },
  watch: {
    showDialog(val) {
      if (!val) {
        this.$refs["rowData"].resetFields()
        this.rowData = {
          userType: [],
          orgName: "",
          orgId: "",
          orgType: "",
          shengjiId: "",
          shijiId: "",
          qujiId: "",
          stationId: "",
          shequjiId: "",
          partyMemberFlag: "0",
          pgdRecord: "0",
          sysType: "0",
        }
      }
    },
    "rowData.orgId"() {
      if (this.$refs.orgId) {
        this.$refs.orgId.dropDownVisible = false //监听值发生变化就关闭它
      }
    },
  },
}
</script>
<style lang="less" scoped>
.el-card {
  border-radius: 16px;
}
/deep/ .el-checkbox {
  margin-right: 28px;
}

.tabBtn {
  margin: 0 !important;
}

#addForm {
  .el-form-item {
    width: 34%;
    display: inline-block;
    vertical-align: top;
  }
}

.oneleft {
  float: left;
  width: 35%;
  margin-top: 25%;
  height: 30%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
  text-align: center;
  flex-wrap: wrap;

  div:first-child {
    width: 100%;
    color: red;
    font-size: 30px;
  }

  div:last-child {
    width: 100%;
  }
}

.oneright {
  float: left;
  width: 65%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: space-around;
  flex-wrap: wrap;

  .onerighttop {
    width: 85%;
    height: 40%;
    margin-top: 5%;
  }

  .onerightbottom {
    width: 85%;
    height: 40%;
  }
}

.dialogArea {
  float: left;
}

.threestyleimg {
  flex: 1.1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 250px;
  height: 250px;
  line-height: 250px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 250px;
  height: 250px;
  display: block;
}

.totalBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.totalItem {
  flex: 0 0 45%;
  height: 103px;
  margin-top: 25px;
  justify-content: center;
  text-align: center;

  .total {
    color: red;
    font-size: 30px;
    margin: 15px 0 10px;
  }

  .name {
    font-size: 12px;
  }
}

.totalItemBg {
  border: 1px solid #dcdcdc;
  background: linear-gradient(to bottom, #fff, #f2f2f2);
}
</style>
